import React from "react"

export const DottedMenuIcon = (props) => {
  return (
    <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <circle fill="#034055" cx={12} cy={3} r={3} />
        <circle fill="#034055" cx={12} cy={12} r={3} />
        <circle fill="#034055" cx={12} cy={21} r={3} />
      </g>
    </svg>
  )
}
